import identity from 'transmute/identity';
import { fetchTasksSettings } from '../../input/tasks/tasksApi';
import { InMemoryCache } from '../InMemoryCache';
export const makeTaskSettingsCache = () => new InMemoryCache('TaskSettingsCache', fetchTasksSettings, identity);